import { Component, Input, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { filter } from 'rxjs/internal/operators/filter';
import { TaskService } from 'src/app/modules/instance/services/task.service';
import { ConfirmationDialogComponent } from 'src/app/shared/components/confirmation-dialog/confirmation-dialog.component';
import { ITaskModel } from 'src/app/shared/interfaces/task-model.interface';

@Component({
    standalone: false,
    selector: 'app-clear-process-threads-button',
    templateUrl: './clear-process-threads-button.component.html',
    styleUrls: ['./clear-process-threads-button.component.scss']
})
export class ClearProcessThreadsButtonComponent implements OnInit {
    @Input()
    public label: string;

    @Input()
    public process: ITaskModel;

    constructor(private readonly taskService: TaskService, private readonly dialog: MatDialog) {}

    ngOnInit(): void {}

    clearThreads() {
        const dialogConfig = new MatDialogConfig();

        dialogConfig.autoFocus = true;
        dialogConfig.data = {
            title: 'Clear Threads',
            topContent: `You are going to clear current calculation threads and stop the task.\n
        Property Records which currently in calculation will be marked with Error status.\n
        Calculation results of canceled threads will be processed if they appear in future.\n
        Do you want to proceed?`
        };
        dialogConfig.maxHeight = '600px';
        dialogConfig.maxWidth = '300px';

        this.dialog
            .open(ConfirmationDialogComponent, dialogConfig)
            .afterClosed()
            .pipe(filter(isConfirm => isConfirm))
            .subscribe(() => {
                this.taskService.clearThreads(this.process).subscribe();
            });
    }
}
